import { TOTAL_SPECIES } from '@/constants/rewards';
import { useRewardsStore } from '@/store/rewards.store';

export function CreaturedexCard() {
  const collection = useRewardsStore((s) => s.collection);
  const summary = useRewardsStore((s) => s.summary);

  const unique = collection?.uniqueSpecies ?? 0;
  const totalHatched = summary?.totalHatched ?? 0;
  const pct = TOTAL_SPECIES > 0 ? Math.round((unique / TOTAL_SPECIES) * 100) : 0;
  const mythics =
    collection?.ownedSpecies.filter((s) => s.rarity === 'epic' || s.rarity === 'legendary')
      .length ?? 0;

  return (
    <div className="rounded-2xl bg-white border border-or-slate-200 p-6 shadow-sm">
      {/* Header row: kicker + percentage */}
      <div className="flex items-start justify-between mb-2">
        <p className="or-kicker" style={{ color: '#1F6A6A' }}>
          Creatures Explored
        </p>
        <span className="text-2xl font-display font-bold tabular-nums" style={{ color: '#1F6A6A' }}>
          {pct}%
        </span>
      </div>

      {/* Big fraction */}
      <div className="flex items-baseline gap-1 mb-1">
        <span className="text-5xl font-display font-bold" style={{ color: '#1F6A6A' }}>
          {unique}
        </span>
        <span className="text-2xl font-display text-or-slate-400">/ {TOTAL_SPECIES}</span>
      </div>
      <p className="text-sm text-or-slate-500 mb-4">unique creatures discovered</p>

      {/* Progress bar */}
      <div className="h-3 rounded-full bg-or-cream-200 mb-6 overflow-hidden">
        <div
          className="h-full rounded-full transition-all duration-500"
          style={{
            width: `${pct}%`,
            background: 'linear-gradient(90deg, #2E8A8A, #1F6A6A)',
          }}
        />
      </div>

      {/* Stats row */}
      <div className="grid grid-cols-2 gap-3">
        <StatBox value={totalHatched} label="Total hatched" />
        <StatBox value={mythics} label="Mythics found" />
      </div>
    </div>
  );
}

function StatBox({ value, label }: { value: number; label: string }) {
  return (
    <div className="flex flex-col items-center rounded-xl border border-or-slate-200 bg-or-cream-50 py-3 px-2">
      <span className="text-xl font-display font-bold tabular-nums" style={{ color: '#334155' }}>
        {value}
      </span>
      <span className="text-[11px] text-or-slate-500 mt-0.5">{label}</span>
    </div>
  );
}
